import { Countries } from 'Constants/Common';
import { RootState } from 'state/store';

export const selectCurrency = (state: RootState) => {
    switch (state.site.country) {
        case Countries.Uk:
            return '£';
        case Countries.Us:
            return '$';
        case Countries.De:
        case Countries.At:
        case Countries.Es:
            return '€';
        default:
            return '£';
    }
};

const selectSiteLocation = (state: RootState) => {
    const { country } = state.site;

    if (country === Countries.Uk) return 'UK';
    if (country === Countries.Us) return 'US';
    if (
        country === Countries.De ||
        country === Countries.At ||
        country === Countries.Es
    )
        return 'EU';

    return 'UNKNOWN';
};

export const selectSiteCountry = (state: RootState) => state.site.country;

export const selectIsUkSite = (state: RootState) =>
    selectSiteLocation(state) === 'UK';

export const selectIsUSSite = (state: RootState) =>
    selectSiteLocation(state) === 'US';

export const selectIsEUSite = (state: RootState) =>
    selectSiteLocation(state) === 'EU';
